
import { Component, Vue } from 'bits/vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import LocaleSelector from 'vuecomponents/LocaleSelectorVuex.vue'

@Component({ components: { OzIcon, OzTextButton, LocaleSelector } })
export default class AuthBottomNav extends Vue {
  OzTextButtonColorScheme = OzTextButtonColorScheme
}
